module.exports = __webpack_public_path__ + "img/3f_l_sapporo@2x.f69530db.png";